import { render, staticRenderFns } from "./PurchaseConditionsDialog.vue?vue&type=template&id=77a7797a"
import script from "./PurchaseConditionsDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseConditionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports